


















































































































































import Vue from 'vue'
import { AxiosResponse } from 'axios'
import NotificationHelper from '../../util/notification_helper'
import { getHostAndDomain } from '../../util/helper'
import { Company, User } from '@/models'
import firebase from 'firebase/compat/app';
import ContactSupport from '@/pmd/components/common/ContactSupport.vue'
import MultipleUsersLogin from '../components/MultipleUsersLogin.vue'
import { OauthService } from '@/services'
import LoginOTPScreen from './LoginOTPScreen.vue'
import config from '@/config'

const MoonLoader = () => import('@/pmd/components/MoonLoader.vue')
export default Vue.extend({
  metaInfo: {
    title: 'Login'
  },
  components: {
    MoonLoader, ContactSupport, MultipleUsersLogin, LoginOTPScreen
  },
  data() {
    return {
      response: '',
      email: '',
      password: '',
      loading: false,
      logoURL: '',
      privacyURL: '',
      termsConditionsURL: '',
      domainCompanyId: null,
      multipleUsersFound: null,
      resetPasswordMsg: false,
      googleAuth: undefined,
      emailMask: '',
      phoneMask: '',
      isOtpScreen: false,
      selectedCompanyId: '',
      isLoginWithGoogleAllowed: false,
      loader: false
    }
  },
  created() {
    this.loader = true
    this.$http
      .get('/api/brand', { params: getHostAndDomain() })
      .then((response: AxiosResponse) => {
        this.logoURL = response.data.logoURL
        this.logoURL && $('link[rel="icon"]').attr('href', this.logoURL)
        this.privacyURL = response.data.privacyURL || 'https://www.gohighlevel.com/privacy'
				this.termsConditionsURL = response.data.termsConditionsURL || response.data.privacyURL || 'https://www.gohighlevel.com/terms-of-service'
        this.domainCompanyId = response.data.companyId
        if(response.data.customCSS) {
          let customCSS = document.createElement('style')
          customCSS.type = 'text/css'
          customCSS.media = 'screen'
          customCSS.appendChild(document.createTextNode(response.data.customCSS))
          document.head.appendChild(customCSS)
        }
        if(response.data.theme) {
          document.body.dataset.theme = response.data.theme
        }
      })
      .catch(err => {
        this.logoURL = 'default'
        this.privacyURL = 'https://www.gohighlevel.com/privacy'
        this.termsConditionsURL = 'https://www.gohighlevel.com/terms-of-service'
      }) .finally(() => {
        
        document.getElementById('app')?.classList.remove('loading')
				this.$store.commit('setAgencyLoaderState',false)
        
        this.loader = false
      });
  },
  mounted() {
    // const checkAndInitGoogle = setTimeout(() => {
    //   if (google && google.accounts) {
    //     this.googleLoginInit();
    //     clearTimeout(checkAndInitGoogle)
    //   } else {
    //     checkAndInitGoogle();
    //   }
    // }, 1000);

    this.isOtpScreen = false;

    if (['dev', 'staging'].includes(config.mode) || getHostAndDomain()?.domain?.includes('gohighlevel')) {
      this.checkAndInitGoogleLogin();
    }

    if (this.$router.currentRoute?.query?.email) {
      this.email = this.$router.currentRoute?.query?.email
    }
    if (this.$router.currentRoute?.query?.reset_password) {
      this.resetPasswordMsg = this.$router.currentRoute?.query?.reset_password
    }
  },
  methods: {
    checkAndInitGoogleLogin(interval = 1) {
      if (window.google && google.accounts) {
        this.googleLoginInit();
      } else {
        setTimeout(() => this.checkAndInitGoogleLogin(interval + 1), interval * 500)
      }
    },
    googleLoginInit() {
      google.accounts.id.initialize({
        client_id: config.googleAuthId,
        callback: (params) => this.submit(false, params)
        // login_uri: 'http://localhost:5001/getTestUrl',
        // ux_mode: 'redirect'
      });
      google.accounts.id.renderButton(
        document.getElementById("g_id_signin"),
        { theme: "outline", size: "large", width: 370 }  // customization attributes
      );
      google.accounts.id.prompt(); // also display the One Tap dialog
      this.isLoginWithGoogleAllowed = true
    },
    async submit(selectedAgencyMultipleUsers?: string, googleAuth: any) {
      if (selectedAgencyMultipleUsers && this.googleAuth) {
        googleAuth = this.googleAuth
      }
      this.googleAuth = googleAuth
      const _self = this
      if (!googleAuth) {
        await this.$validator.validateAll()
        if (this.errors.any()) {
          return Promise.resolve(true)
        }
      }

      this.loading = true
      this.response = ''

      const params = {
        ...getHostAndDomain(),
        email: this.email.trim(),
        password: this.password.trim(),
        deviceId: await _self.$store.dispatch('getDeviceId'),
        deviceType: 'web',
        deviceName: navigator.userAgent,
        token: googleAuth?.credential
      } as { [key: string]: any }
      this.selectedCompanyId = undefined

      if (this.domainCompanyId && this.domainCompanyId !== 'YuTUZlUtrwBtvmgByZDW') {
        params.companyId = this.domainCompanyId // When logging in from White Label domain
        this.selectedCompanyId = this.domainCompanyId
      } else if (selectedAgencyMultipleUsers) {
        params.companyId = selectedAgencyMultipleUsers // When selecting an Agency because of Multiple Users
        this.selectedCompanyId = selectedAgencyMultipleUsers
      }

      if(googleAuth) {
        // remove these properties because auth with throw err. Refer to GoogleLoginDto in MP repo
        delete params.domain
        delete params.subdomain
        delete params.email
        delete params.password
      }

      OauthService.loginWithEmail(params, googleAuth ? 'google' : 'email').then(
        (response: AxiosResponse) => {
          if (response.multipleUsers) {
            this.multipleUsersFound = response.multipleUsers
            this.loading = false
          } else {
            if (!googleAuth && !response.token) {
              this.emailMask = response.email;
              this.phoneMask = response.phone;
              this.isOtpScreen = true;
              return
            }

            this.$store
            .dispatch('auth/set', {
              apiKey: response.apiKey,
              userId: response.userId,
              companyId: response.companyId,
              jwt: response.jwt,
              refreshJwt: response.refreshJwt
            })
            .then(() => {
              return this.$auth.signInWithCustomToken(response.token)
            })
            .then(async () => {
              this.$store.dispatch('auth/set', {
                firebaseToken: response.token,
                apiKey: response.apiKey,
                userId: response.userId,
                companyId: response.companyId,
                jwt: response.jwt,
                refreshJwt: response.refreshJwt
              });
              NotificationHelper.requestPermission()
              this.$store.dispatch('init')
              const loginCount = firebase.firestore.FieldValue.increment(1)
              await User.collectionRef()
              .doc(response.userId).update({ login_count: loginCount })
              const url = this.$route.query.url
              if (url) {
                this.$router.push({
                  path: decodeURIComponent(url),
                  replace: true
                })
              } else {
                console.info('Redirect to dashboard')
                this.$router.push({ name: 'dashboard', replace: true })
              }
            })
          }
        }
      ).catch(reason => {
        this.response = reason.response
          ? reason.response.data.message
          : 'Unable to log you in at this time.'
        this.loading = false
      })
    },
    async selectAgencyMultipleUser(selectedAgencyMultipleUsers) {
      this.multipleUsersFound = null
      await this.submit(selectedAgencyMultipleUsers)
    }
  }
})
